import { Component } from 'react'
import * as styles from 'components/features/pfm/CreditSummaryModule/CreditSummaryModule.css'
import CreditChart from 'components/features/pfm/CreditChart/CreditChart'
import ChartHeader from 'components/atoms/charts/ChartHeader'
import { CommonChartValues } from 'interfaces/chart'
import { Omit } from 'interfaces/index'
import Button from 'components/features/pfm/Button/Button'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { getCreditStatusGradeLabel } from 'helpers/creditHelpers'

type CreditscoreTotals = Omit<CommonChartValues, 'memberValue'> & { memberValue: number | null }

export type CreditSummaryStateProps = {
  selectedPeergroupName: string
  totals: CreditscoreTotals
  showLinkCreditButton: boolean
  withComparison: boolean
}

class CreditSummaryModule extends Component<CreditSummaryStateProps> {

  render () {
    const { selectedPeergroupName, totals, showLinkCreditButton, withComparison } = this.props
    const { memberValue, peerValue, otherValue } = totals
    const memberDisplayValue = memberValue ? this.decorateValue(memberValue) : ''
    const memberSecondaryDisplayValue = memberValue ? getCreditStatusGradeLabel(memberValue) : ''

    const memberSecondRow = showLinkCreditButton ? (
      <div className={ styles.linkCreditButtonWrapper }>
        <NavigationLink to='credit-linkage'>
          <Button size='tiny' text='See Your Score' wrapText />
        </NavigationLink>
      </div>
    ) : (
      this.renderCreditStatusLabel(memberSecondaryDisplayValue)
    )

    const member = (
      <>
        { memberDisplayValue }
        { memberSecondRow }
      </>
    )
    const peers = (
      <>
        { this.decorateValue(peerValue) }
        { this.renderCreditStatusLabel(getCreditStatusGradeLabel(peerValue)) }
      </>
    )
    const others = (
      <>
        { this.decorateValue(otherValue) }
        { this.renderCreditStatusLabel(getCreditStatusGradeLabel(otherValue)) }
      </>
    )

    return (
      <div className={ styles.creditSummaryModule }>
        <ChartHeader
          member={{
            label: 'You',
            value: member,
          }}
          peers={{
            label: 'Your Peers',
            value: peers,
          }}
          others={{
            label: selectedPeergroupName,
            value: others,
          }}
          withComparison={ withComparison }
        />
        <div className={ styles.chartWrapper }>
          <CreditChart { ...totals } withComparison={ withComparison } />
        </div>
      </div>
    )
  }

  renderCreditStatusLabel (label: string) {
    return (
      <div className={ styles.label }>
        { label }
      </div>
    )
  }

  private decorateValue (value: number) {
    return Math.round(value).toString()
  }
}

export default CreditSummaryModule
